import { initialState } from "./state"

export default {
  resetCore: state => {
    const init_state = initialState()
    Object.keys(state).forEach(key => {
      state[key] = init_state[key]
    })
  },
  setCurrentStep: (state, payload) => (state.currentStep = payload),
  setLoading: (state, payload) => (state.loading = payload)
}
